import { render, staticRenderFns } from "./InstrForTasks.vue?vue&type=template&id=dff0dc34"
import script from "./InstrForTasks.vue?vue&type=script&lang=js"
export * from "./InstrForTasks.vue?vue&type=script&lang=js"
import style0 from "./InstrForTasks.vue?vue&type=style&index=0&id=dff0dc34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports